export default __webpack_public_path__ + "static/media/sace-bg.91706b41.png";